import CanonicalLinkSelector from './CanonicalLinkSelector';
import ExactIdMatchSelector from './ExactIdMatchSelector';
import LocationSelector from './201LocationSelector';
import PartialCollectionViewSelector from './PartialCollectionViewSelector';
import RedirectTargetSelector from './RedirectTargetSelector';
import TrailingSlashSelector from './TrailingSlashSelector';
export const AllDefault = {
    1: PartialCollectionViewSelector(CanonicalLinkSelector),
    2: PartialCollectionViewSelector(LocationSelector),
    3: PartialCollectionViewSelector(ExactIdMatchSelector),
    4: PartialCollectionViewSelector(TrailingSlashSelector),
    5: PartialCollectionViewSelector(RedirectTargetSelector),
};
//# sourceMappingURL=index.js.map